const roleColors: Record<string, string> = {
  admin: 'blue',
  user: 'green',
  auth: 'red',
  retainers: 'yellow',
  loans: 'purple',
  dex: 'orange',
  vc: 'pink',
  telegram: 'cyan',
};

/**
 * Resolves the antd `Tag` color for a role-style name from its domain prefix
 * (the part before the first dot, e.g. `loans` for `loans.viewer`).
 *
 * Lives in its own util package rather than `@skynet/sky-role` because the
 * Users, Tenants and Items admin pages color their tags the same way, and
 * none of them should depend on the Roles UI package.
 *
 * @returns the preset color name, or `undefined` for an unknown domain so the
 * tag falls back to antd's default color.
 */
export function getRoleColor(roleName: string): string | undefined {
  const domain = roleName.split('.')[0];
  return roleColors[domain];
}
